export type TargetingConflictType = 'Bidders' | 'Campaigns';

export interface ITargetingConflictTableConfig {
  cypressClassName: string;
  type: TargetingConflictType;
  nameReplacement: string; // used to replace header
}

export const targetingConflictsDrawerConfig: Record<string, ITargetingConflictTableConfig> = {
  bidders: {
    cypressClassName: 'bidder_conflicts',
    type: 'Bidders',
    nameReplacement: 'Bidder Conflicts',
  },
  campaigns: {
    cypressClassName: 'campaign_conflicts',
    type: 'Campaigns',
    nameReplacement: 'Campaign Conflicts',
  },
};
